import {Component, Input} from '@angular/core';

@Component({
  selector: 'iw-shared-layout-content-loading',
  templateUrl: './content-loading.component.html',
  styleUrls: ['./content-loading.component.scss']
})
export class ContentLoadingComponent {

  @Input() loading!: boolean;


  constructor() {


  }

}
